var _keyMirror=require('fbjs/lib/keyMirror');var _keyMirror2=_interopRequireDefault(_keyMirror);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var ImageResizeMode=(0,_keyMirror2.default)({
center:null,
contain:null,
cover:null,
none:null,
repeat:null,
stretch:null});


module.exports=ImageResizeMode;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-native-web/dist/components/Image/ImageResizeMode.js
 ** module id = 277
 ** module chunks = 0
 **/